import { useState } from 'react';
import { ExternalLink } from 'lucide-react';
import LaunchStoreModal from '../../../components/LaunchStoreModal';
import { launchStore } from '../../../utils/launchStore';

// "View Store" header button, on every store for every user. What it opens
// depends on the store's storefront type (Store - General) -- see
// utils/launchStore.js.
export default function ViewStoreButton({ store }) {
	const [launchOpen, setLaunchOpen] = useState(false);
	const isIframe = store.storefrontType === 'iframe';

	return (
		<>
			<button
				type='button'
				className='btn-secondary flex items-center gap-1.5'
				title={
					store.storeDomain
						? isIframe
							? `Open ${store.storeDomain} in an iframe test page`
							: `Open ${store.storeDomain} in a new tab`
						: undefined
				}
				onClick={() => launchStore(store, () => setLaunchOpen(true))}
			>
				<ExternalLink className='size-4' />
				View Store
			</button>
			{!isIframe && (
				<LaunchStoreModal
					open={launchOpen}
					setOpen={setLaunchOpen}
					storeId={store.storeId}
					storeName={store.storeName}
					allowGuestCheckout={store.allowGuestCheckout}
				/>
			)}
		</>
	);
}
